import { PurchasecodeGet, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController, getIdWithCompany } from "../utils";
import { PurchaseCode } from "./interfaces";

export const makePurchaseCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: codes,
        allLoading: loading,
        listen: listenCompany,
    } = createListController<PurchasecodeGet, PurchaseCode, string>({
        name: "purchasecode",
        connection,
        view: (item, company) => ({
            ...item,
            company,
            id: getIdWithCompany(item.id, company),
            _id: item.id,
        }),
        list: (con, company) => con.purchasecode.items({ company }),
        getId: (item, company) => getIdWithCompany(item.id, company),
        getKey: (company) => company,
    });

    const listen = () => listenCompany(company.value);

    const get = (
        id: string | Readonly<Ulid> | null | undefined,
        cmp = company.value,
    ) => {
        if (!id) {
            return null;
        }

        const key = getIdWithCompany(id, cmp);

        return codes.value.find((s) => s.id === key) ?? null;
    };

    return {
        codes,
        loading,
        listen,
        listenCompany,
        get,
    };
};
